
const getServices = "https://digitalgreenskills.buildgreenalbania.org/blogMng.php?/getServices";

const getNews = "https://digitalgreenskills.buildgreenalbania.org/blogMng.php?/getNews";

const getComponent = "https://digitalgreenskills.buildgreenalbania.org/blogMng.php?/get";

const sendMail = "https://digitalgreenskills.buildgreenalbania.org/blogMng.php?/postEmail";

const getFileData = "https://digitalgreenskills.buildgreenalbania.org/blogMng.php?/getFileData";

const getMapsFileList = "https://buildgreenalbania.org/blogMng.php?/getMapsPath";

const mapsPath = "https://buildgreenalbania.org/maps";


export default {
    getServices,
    getNews,
    getComponent,
    sendMail,
    getFileData,
    getMapsFileList,
    mapsPath
} 



// WEBPACK FOOTER //
// ./src/APICall/Api.jsx